// app/components/CatalogueErrorFallback.tsx

import React from 'react';
import {StyleSheet, View} from 'react-native';
import {useQueryClient} from '@tanstack/react-query';

import {logger} from '../utils/logger';

import Button from './themed/Button';
import Text from './ui-controls/Text';

interface Props {
  error: Error;
  resetErrorBoundary: () => void;
}

export const CatalogueErrorFallback: React.FC<Props> = ({error, resetErrorBoundary}) => {
  const queryClient = useQueryClient();

  const handleRetry = () => {
    logger.info('CatalogueErrorFallback', 'User initiated retry');

    // Invalidate catalogue queries to force refetch
    queryClient.invalidateQueries({queryKey: ['catalogue']});

    // Reset error boundary (re-renders children)
    resetErrorBoundary();
  };

  return (
    <View style={styles.container} testID="catalogue-error-fallback">
      <Text style={styles.title}>Unable to Load Catalogue</Text>
      <Text style={styles.message}>
        {error.message || 'An unexpected error occurred while loading the catalogue.'}
      </Text>
      <Text style={styles.hint}>Please check your internet connection and try again.</Text>
      <Button onPress={handleRetry} style={styles.button}>
        Retry
      </Button>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 12,
    textAlign: 'center',
  },
  message: {
    fontSize: 16,
    marginBottom: 8,
    textAlign: 'center',
    color: '#666',
  },
  hint: {
    fontSize: 14,
    marginBottom: 24,
    textAlign: 'center',
    color: '#999',
  },
  button: {
    minWidth: 120,
  },
});
